module.exports = __webpack_public_path__ + "static/img/module-stop-topimg_5.c5bb855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/module-stop-topimg_5.png
// module id = b094
// module chunks = 0